module.exports = __webpack_public_path__ + "img/ic_ssl.9e6650f2.svg";